import React, { FC } from 'react';

import { ILibModalSizes, Modal } from '@infologistics/frontend-libraries';

import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { resetModal } from '@store/modules/modal';

import { IModalProps as IProps } from '@common/ModalWrapper/types';
import { useTranslation } from 'react-i18next';

const ModalWrapper: FC<IProps> = (props) => {
  const {
    children,
    size = ILibModalSizes.SMALL,
    disableHideFn
  } = props

  const { t } = useTranslation(['common'])

  const { modal } = useAppSelector(state => state.modal)

  const dispatch = useAppDispatch()

  const handleModalHide = disableHideFn
    ? () => null
    : () => (dispatch(resetModal()))

  return (
    <Modal
      {...props}
      idFromState={modal || ''}
      size={size}
      closeText={t('common:close')}
      hideModal={handleModalHide}
    >
      { children }
    </Modal>
  );
}

export default ModalWrapper
